export const EXCLUDED_COUNTRIES: string[] = [
  'US',
  'AI',
  'AG',
  'BS',
  'BB',
  'VG',
  'CA',
  'DO',
  'PR',
  'JM',
  'AS',
  'BM',
  'KY',
  'DM',
  'GD',
  'GU',
  'MS',
  'MP',
  'KN',
  'LC',
  'VC',
  'SX',
  'TT',
  'TC',
  'VI',
  'AQ',
  'TF',
  'UM',
];
